import { render, staticRenderFns } from "./Approvainfo.vue?vue&type=template&id=abe4781c&scoped=true&"
import script from "./Approvainfo.vue?vue&type=script&lang=js&"
export * from "./Approvainfo.vue?vue&type=script&lang=js&"
import style0 from "./Approvainfo.vue?vue&type=style&index=0&id=abe4781c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe4781c",
  null
  
)

export default component.exports